(() => {
  if (window.K9PairsWellLoaded) {
    window.K9PairsWellInit?.();
    return;
  }

  window.K9PairsWellLoaded = true;

  function initPairsWell(scope = document) {
    scope.querySelectorAll('[data-pairs-well]').forEach((section) => {
      initPairsWellSection(section, 0);
    });
  }

  function initPairsWellSection(section, attempt) {
    const swiperEl = section.querySelector('.pairs-well__swiper');
    if (!swiperEl || swiperEl.dataset.pairsSwiperInit === '1') return;

    if (!window.Swiper) {
      if (attempt > 25) return;

      window.setTimeout(() => {
        initPairsWellSection(section, attempt + 1);
      }, 160);

      return;
    }

    swiperEl.dataset.pairsSwiperInit = '1';

    new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 12,
      loop: false,
      speed: 520,
      watchOverflow: true,
      resistanceRatio: 0.7,
      threshold: 6,
      navigation: {
        prevEl: section.querySelector('.pairs-well__arrow--prev'),
        nextEl: section.querySelector('.pairs-well__arrow--next'),
        disabledClass: 'swiper-button-disabled'
      }
    });
  }

  function parseVariants(root) {
    const jsonEl = root?.querySelector('[data-pairs-variants-json]');
    if (!jsonEl) return [];

    try {
      return JSON.parse(jsonEl.textContent.trim());
    } catch (_) {
      return [];
    }
  }

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format || window.money_format || '${{amount}}');
    }

    const amount = (Number(cents || 0) / 100).toFixed(2);
    return `$${amount}`;
  }

  function setButtonText(button, text) {
    if (!button) return;

    const textEl = button.querySelector('[data-pairs-submit-text]') || button.querySelector('span');

    if (textEl) {
      textEl.textContent = text;
      return;
    }

    button.textContent = text;
  }

  function updateVariantImage(root, variant) {
    if (!root || !variant || !variant.image || !variant.image.src) return;

    const img = root.querySelector('[data-pairs-image]');
    if (!img) return;

    img.src = variant.image.src;

    if (variant.image.srcset) {
      img.srcset = variant.image.srcset;
    } else {
      img.removeAttribute('srcset');
    }

    if (variant.image.alt) {
      img.alt = variant.image.alt;
    }
  }

  function applyVariant(root, variant) {
    const idInput = root.querySelector('[data-pairs-variant-id]');
    const priceEl = root.querySelector('[data-pairs-price]');
    const submit = root.querySelector('[data-pairs-submit]');

    if (!variant) {
      if (idInput) idInput.disabled = true;

      if (submit) {
        submit.disabled = true;
        setButtonText(submit, 'UNAVAILABLE');
      }

      return;
    }

    if (idInput) {
      idInput.value = variant.id;
      idInput.disabled = !variant.available;
    }

    if (priceEl && variant.price != null) {
      priceEl.textContent = formatMoney(variant.price, root.dataset.moneyFormat);
    }

    updateVariantImage(root, variant);

    if (submit) {
      submit.disabled = !variant.available;
      setButtonText(submit, variant.available ? 'ADD TO CART' : 'SOLD OUT');
    }
  }

  function updateQuickBuy(root) {
    if (!root) return;

    const variants = parseVariants(root);
    if (!variants.length) return;

    const groups = Array.from(root.querySelectorAll('[data-pairs-option-group]'));

    if (!groups.length) {
      const idInput = root.querySelector('[data-pairs-variant-id]');
      const currentId = idInput ? String(idInput.value) : '';
      const currentVariant = variants.find((variant) => String(variant.id) === currentId) || variants[0];

      applyVariant(root, currentVariant);
      return;
    }

    const selected = groups
      .sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex))
      .map((group) => {
        const active = group.querySelector('[data-pairs-option-value][aria-pressed="true"]');
        return active ? active.dataset.pairsOptionValue : null;
      });

    const match = variants.find((variant) => {
      if (!variant.options || variant.options.length !== selected.length) return false;

      return variant.options.every((value, index) => {
        return String(value) === String(selected[index]);
      });
    });

    applyVariant(root, match);
  }

  function getActiveQuickBuy() {
    return document.querySelector('right-drawer [data-pairs-quickbuy]');
  }

  function validatePairsDrawerForm(form) {
    const requiredFields = Array.from(form.querySelectorAll('[required]'));

    for (const field of requiredFields) {
      const value = String(field.value || '').trim();

      if (!value) {
        field.classList.add('is-invalid');

        try {
          field.reportValidity();
        } catch (_) {}

        field.focus();
        return false;
      }

      field.classList.remove('is-invalid');
    }

    return true;
  }

  function closeRightDrawerAfterSubmit() {
    window.setTimeout(() => {
      const drawer = document.querySelector('right-drawer.rd-open');
      drawer?.close?.();
    }, 650);
  }

  window.K9PairsWellInit = initPairsWell;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initPairsWell());
  } else {
    initPairsWell();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initPairsWell(event.target);
  });

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-pairs-quickbuy-open]');

    if (opener) {
      window.setTimeout(() => {
        updateQuickBuy(getActiveQuickBuy());
      }, 90);
    }

    const valueButton = event.target.closest('[data-pairs-option-value]');
    if (!valueButton) return;

    const group = valueButton.closest('[data-pairs-option-group]');
    const root = valueButton.closest('[data-pairs-quickbuy]');

    if (!group || !root) return;

    group.querySelectorAll('[data-pairs-option-value]').forEach((button) => {
      button.setAttribute('aria-pressed', button === valueButton ? 'true' : 'false');
    });

    updateQuickBuy(root);
  });

  document.addEventListener('input', (event) => {
    const input = event.target.closest('.pairs-rd__input');
    if (!input) return;

    if (String(input.value || '').trim()) {
      input.classList.remove('is-invalid');
    }
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target.closest('right-drawer [data-type="add-to-cart-form"]');
      if (!form || !form.closest('[data-pairs-quickbuy]')) return;

      if (!validatePairsDrawerForm(form)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      closeRightDrawerAfterSubmit();
    },
    true
  );
})();